import {
  DeviceCapabilities,
  SiteCapabilities,
  StudyCapabilities,
} from 'adc-sirius-module-common';
import { OrganizationCapabilities } from 'adc-sirius-module-common';
import { queryOptions, UseQueryOptions } from '@tanstack/react-query';
import { ApiErrorResponse } from '../models';
import mediator from '../utilities/mediator';
import log from '../utilities/log';

type CapabilitiesQueryParams = {
  key?: string;
};

export function organizationCapabilitiesQueryOptions(
  params: CapabilitiesQueryParams,
  options?: Partial<UseQueryOptions<OrganizationCapabilities>>,
) {
  return queryOptions<OrganizationCapabilities>({
    ...options,
    queryKey: ['capabilityOrganization', params.key],
    queryFn: async () => {
      try {
        return await mediator.request<OrganizationCapabilities>(
          'capability:getOrganizationCapabilities',
          { ...params },
        );
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
    enabled: !!params.key,
  });
}

export function studyCapabilitiesQueryOptions(
  params: CapabilitiesQueryParams,
  options?: Partial<UseQueryOptions<StudyCapabilities>>,
) {
  return queryOptions<StudyCapabilities>({
    ...options,
    queryKey: ['capabilityStudy', params.key],
    queryFn: async () => {
      try {
        return await mediator.request<StudyCapabilities>(
          'capability:getStudyCapabilities',
          { ...params },
        );
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
    enabled: !!params.key,
  });
}

export function siteCapabilitiesQueryOptions(
  params: CapabilitiesQueryParams,
  options?: Partial<UseQueryOptions<SiteCapabilities>>,
) {
  return queryOptions<SiteCapabilities>({
    ...options,
    queryKey: ['capabilitySite', params.key],
    queryFn: async () => {
      try {
        return await mediator.request<SiteCapabilities>(
          'capability:getSiteCapabilities',
          { ...params },
        );
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
    enabled: !!params.key,
  });
}

export function deviceCapabilitiesQueryOptions(
  params: CapabilitiesQueryParams,
  options?: Partial<UseQueryOptions<DeviceCapabilities>>,
) {
  return queryOptions<DeviceCapabilities>({
    ...options,
    queryKey: ['capabilityDevice', params.key],
    queryFn: async () => {
      try {
        return await mediator.request<DeviceCapabilities>(
          'capability:getDeviceCapabilities',
          { ...params },
        );
      } catch (error: any) {
        log.error(error);
        throw new ApiErrorResponse(error.status, error.message);
      }
    },
    enabled: !!params.key,
  });
}
